export type MaterialUsed = {
  item_type: string
  quantity: number
  usage_outcome?: string | null
  unit_of_measure?: string
  source?: string | null
  label?: string
}

export function materialOutcomeLabel(outcome?: string | null) {
  if (outcome === "installed") return "Installed"
  if (outcome === "consumed") return "Consumed"
  return null
}

export function materialDisplayLabel(row: MaterialUsed) {
  return row.label || `${row.item_type} ×${row.quantity}`
}

export function isStoredUploadPath(path: string | null | undefined) {
  if (!path) return false
  return !path.startsWith("http://") && !path.startsWith("https://")
}

/** @deprecated use MaterialUsed */
export type TaskMaterialUsed = MaterialUsed

/** @deprecated use isStoredUploadPath */
export const isStoredTaskProof = isStoredUploadPath
